import { Injectable } from '@angular/core';
import { CommonService } from '../common.service';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(private router: Router, private _commonservice: CommonService) { }


    _getloginotp(Mobileno) {
        debugger
        const params = new HttpParams().set('Mobileno', Mobileno);
        return this._commonservice.getAPI('/SendloginOtp', params, 'YES')
    }

 
    _verifyotp(Mobileno,otp)
    {
        const params = new HttpParams().set('Mobileno', Mobileno).set('otp',otp);
        return this._commonservice.getAPI('/verifyotp', params, 'YES')
    }
    _getUser() {
        return JSON.parse(sessionStorage.getItem('currentUser'));
    }

    Logout() {
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('pToken');
        sessionStorage.removeItem('UFM');
        this.router.navigate(['/']);
    }
    _getRoles() {
      
        return sessionStorage.getItem('UFM');
    }

   

}